import React from "react";
import { Navigate } from "react-router-dom";
import type { Session } from "@supabase/supabase-js";
import { useAuth } from "@/contexts/AuthContext";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user, session, loading, userRole } = useAuth();

  console.log("AdminRoute - user:", user?.id, "userRole:", userRole, "loading:", loading);

  // Check if session is expired
  const isSessionExpired = (s: Session | null): boolean => {
    if (!s || !s.expires_at) return true;
    const expiresAt = s.expires_at * 1000;
    const now = Date.now();
    return now >= expiresAt;
  };

  // Still loading auth or role hasn't resolved yet
  if (loading || (user && userRole === null)) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Redirect if not authenticated or session expired
  if (!user || !session || isSessionExpired(session)) {
    return <Navigate to="/" replace />;
  }

  if (userRole !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
